/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {DetailFormFormComponent as ɵc} from './detailform-form/detailform-form.component';
export {DetailFormComponent as ɵb} from './detailform.component';
export {declaration as ɵa} from './detailform.module';
export {DetailFormRoutes as ɵd} from './detailform.routing';